import React, { Component, Fragment } from "react";
import { SubscriptionCategoryDetailModel } from "./models/subscription.category.detail.model";
import { SubscriptionCategoryService } from "./services/subscription.category.service";
import { HttpResponse } from "../../../../core";
import {
  HandleNotFoundResponse
} from "../../../../shared/helpers";
import { NotFoundResponseArea } from "../../../../shared/enums";
import { SubscriptionCategoryTabs } from "./SubscriptionCategoryTabs";
import { Loader } from "../../../../shared/loaders";

interface IState {
  result?: SubscriptionCategoryDetailModel;
  isLoading?: boolean;
}

export class SubscriptionCategoryDetail extends Component<any, IState> {
  private service: SubscriptionCategoryService;
  constructor(props) {
    super(props);
    this.state = this.initialState;
    this.service = new SubscriptionCategoryService();
  }

  // Defines the initial state for the values coming from API.
  initialState: Partial<IState> = {
    result: {
      id: 0,
      name: "",
      label: "",
    },
    isLoading: false,
  };

  //Get the detail from the API whenever the page loads.
  componentDidMount() {
    this.loadData();
  }

  //function to load the initial view data coming from the API.
  private setLoading(loading: boolean) {
    this.setState({ isLoading: loading });
}
loadData() {
    this.setLoading(true);
    this.service
      .getSubscriptionCategoryById(this.props.match.params.id)
      .then((res: HttpResponse<SubscriptionCategoryDetailModel>) => {
        this.setLoading(false);
        if (res && res.result) {
          this.setState({
            result: res.result,
          });
        }
      })
      .catch((ex) => {
        HandleNotFoundResponse(ex, NotFoundResponseArea.SubscriptionCategory, this.props);
      });
  }

  render() {
    return (
      <Fragment>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h5>Details for Subscription Category '{this.state.result?.name}'</h5>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <SubscriptionCategoryTabs
                  id={this.props.match.params.id}
                  url="/subscription-category/detail/"
                />
                {!this.state.isLoading &&  <>        
                <h5 className="mb-3">Basic Info</h5>
                <div className="row">
                  {this.state.result?.name && (
                    <div className="col-4">
                      <div className="card card-silver shadow-sm">
                        <div className="card-header">
                          <b>Name</b>
                        </div>
                        <div className="card-body">
                          {this.state.result?.name}
                        </div>
                      </div>
                    </div>
                  )}
                  {this.state.result?.label && (
                    <div className="col-4">
                      <div className="card card-silver shadow-sm">
                        <div className="card-header">
                          <b>Label</b>
                        </div>
                        <div className="card-body">
                          {this.state.result?.label}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                </>}                 
                                {this.state.isLoading && <Loader loading={this.state.isLoading} />}   
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
